import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./generalSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function GeneralSuccessPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup} data-testid="success-popup">
      <div className={popupStyles.popup__content}>
        <button className={popupStyles.popup__closeBtn} onClick={onClose} />
        <h2 className={popupStyles.popup__title}>{t('DATA_UPDATED_SUCCESSFULLY')}</h2>
        <img
          src={doctor}
          alt={t('IMAGE_OF_VENUS')}
          className={popupStyles.popup__img}
        />
        <button
          className={`button hover ${popupStyles.popup__nextBtn}`}
          data-testid="success-popup-ok-button"
          onClick={onClose}
        >
          {t('APPROVAL')}</button>
      </div>
    </article>
  );
}

export default GeneralSuccessPopup;
